import {constants, type RelationshipsAPI} from '@wix/document-manager-extensions'
import _ from 'lodash'
import type {HostWithViewerManager} from '../host/host'
import type {Pointer} from '@wix/document-services-types'

const {VIEWER_PAGE_DATA_TYPES, VIEW_MODES} = constants

export const getParkingLotPOCAPI = (host: HostWithViewerManager, dsDebug: any) => {
    const {extensionAPI, dal} = host.documentManager
    const {relationships} = extensionAPI as RelationshipsAPI
    const {viewerManager} = host
    const getPageAsParkingLot = (pageId: string) => {
        const getItemsToRemove = (pointer: Pointer, referred: Pointer[] = []) => {
            const nextReferred = relationships.getOwnedReferredPointers(pointer).filter(p => {
                return p.type !== 'DESKTOP' || dal.get(p).componentType !== 'responsive.components.Section'
            })
            referred.push(...nextReferred)
            nextReferred.forEach(next => getItemsToRemove(next, referred))
            return referred
        }

        const getPageItemsAsFragment = () =>
            _(dsDebug.getMergedStore())
                .mapValues(map =>
                    _(map)
                        .pickBy({metaData: {pageId}})
                        .mapValues(v =>
                            _.assign({}, v, {
                                metaData: {
                                    fragmentType: 'ParkingLot',
                                    fragmentInstance: `${pageId}-ParkingLot`
                                }
                            })
                        )
                        .value()
                )
                .omitBy(_.isEmpty)
                .value()

        const storeForFragment = getPageItemsAsFragment()
        getItemsToRemove({id: pageId, type: 'DESKTOP'}).forEach(pointer => {
            delete storeForFragment[pointer.type]?.[pointer.id]
        })
        delete storeForFragment.DESKTOP?.[pageId]
        _.forOwn(storeForFragment.DESKTOP!, comp => {
            if (comp.componentType === 'responsive.components.Section') {
                delete comp.parent
            }
        })

        return _.pickBy(
            storeForFragment,
            (map, namespaceName) =>
                (VIEWER_PAGE_DATA_TYPES[namespaceName] || VIEW_MODES[namespaceName]) && !_.isEmpty(map)
        )
    }
    const setFragmentStoreToViewer = (fragmentStore: any, shouldRemove = false) => {
        viewerManager.actions.runInBatch(() => {
            _.forEach(fragmentStore, (dataMap, namespaceName) =>
                _.forEach(dataMap, (item, itemId) => {
                    const pointer = {id: itemId, type: namespaceName}
                    if (shouldRemove) {
                        viewerManager.dal.remove(pointer)
                    } else {
                        viewerManager.dal.set(pointer, item)
                    }
                })
            )
        })
    }

    return {
        getPageAsParkingLot,
        setPageAsParkingLotToViewer: (pageId: string) => setFragmentStoreToViewer(getPageAsParkingLot(pageId)),
        removePageAsParkingLotFromViewer: (pageId: string) =>
            setFragmentStoreToViewer(getPageAsParkingLot(pageId), true)
    }
}
